import { Nullable } from "common/records";
import {
  IPricePresentationSlideData,
  PricePresentationSlideRecord,
  pricePresentationSlideFromJSON,
} from "common/records/PricePresentationSlide";
import { List, Map, Record } from "immutable";

export const enhancedPricePresentationConfigFromJSON = (
  json: Partial<IEnhancedPricePresentationConfigData>,
): EnhancedPricePresentationConfigRecord => {
  const recordData: IEnhancedPricePresentationConfigRecord = { ...(json as any) };

  if (Array.isArray(json.same_as_cash)) {
    recordData.same_as_cash = List(json.same_as_cash);
  }

  if (Array.isArray(json.slides)) {
    recordData.slides = List(json.slides.map(pricePresentationSlideFromJSON));
  }

  if (json.titles) {
    for (const key of Object.keys(json.titles || {})) {
      if (json.titles?.[key].trim() === "") {
        delete json.titles[key];
      }
    }

    recordData.titles = Map<string, string>(json.titles);
  }

  return new EnhancedPricePresentationConfigRecord(recordData);
};

export const enhancedPricePresentationConfigToJSON = (record: EnhancedPricePresentationConfigRecord) => {
  const json = record.toJS() as Partial<IEnhancedPricePresentationConfigData>;

  for (const key of Object.keys(json.titles || {})) {
    if (json.titles?.[key].trim() === "") {
      delete json.titles[key];
    }
  }

  return json;
};

export interface IEnhancedPricePresentationConfigData {
  enable_current_discounts?: boolean;
  enabled?: boolean;
  max_payment_range?: Nullable<number>;
  min_payment_range?: Nullable<number>;
  round_by_default?: boolean;
  same_as_cash?: string[];
  slides?: Partial<IPricePresentationSlideData>[];
  titles?: { [key: string]: string };
}

export interface IEnhancedPricePresentationConfigRecord {
  enable_current_discounts: boolean;
  enabled: boolean;
  max_payment_range: Nullable<number>;
  min_payment_range: Nullable<number>;
  round_by_default: boolean;
  same_as_cash: List<string>;
  slides: List<PricePresentationSlideRecord>;
  titles: Map<string, string>;
}

export const defaultEnhancedPricePresentationConfig: IEnhancedPricePresentationConfigRecord = {
  enable_current_discounts: false,
  enabled: false,
  max_payment_range: null,
  min_payment_range: null,
  round_by_default: false,
  same_as_cash: List(),
  slides: List(),
  titles: Map<string, string>(),
};

export class EnhancedPricePresentationConfigRecord
  extends Record(defaultEnhancedPricePresentationConfig)
  implements IEnhancedPricePresentationConfigRecord {}
